<template>
	<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
	<div>
		<div class="tw-mb-1 tw-flex tw-gap-2">
			<span>{{ stepNumber }}.</span>
			<p>
				<span>{{ $t('integrations.copy-the') }} </span>
				<span class="tw-mx-1 tw-inline-block tw-text-brand-500">
					{{ $t('integrations.Business-ID') }}
				</span>
				<span>{{ $t('integrations.from-below-and-paste-it-1-turn-on-the') }} </span>
				<span class="tw-mx-1 tw-inline-block tw-text-brand-500">
					{{ $t('integrations.everything') }}
				</span>
				<span>{{ $t('integrations.toggle-2-click-invite-3') }} </span>
			</p>
		</div>

		<div class="tw-mb-2">
			<AppInput
				:label="$t('integrations.Business-ID')"
				v-model="businessID"
				size="sm"
				class="tw-max-w-[435px]"
				:disabled="true"
			>
				<template #end-btn>
					<AppButton tertiary size="lg" variant="gray" @click="copyToClipboard()">
						<AppIcon name="copy" />
					</AppButton>
				</template>
			</AppInput>
		</div>

		<img :src="`${imgUrl}/invite-and-assign-access.png`" class="tw-rounded-sm" />
	</div>
</template>

<script setup>
const props = defineProps({
	imgUrl: String,
	stepNumber: Number,
});

const businessID = process.env.FB_NAMAA_BUSINESS_ID || 361086041031841;

const copyToClipboard = async () => {
	try {
		await navigator.clipboard.writeText(businessID);
	} catch (err) {
		console.error('Failed to copy text: ', err);
	}
};
</script>

<style lang="scss" scoped></style>
